import React, { useState , useEffect } from "react";
import { Link } from "react-router-dom";

import { Button, Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faPhone,
	faUser,
	faRandom,
	faPenFancy,
	faYinYang,
    faPen,
    faRocket,
    faPaperclip,
} from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";

import pic from '../assets/images/5.png'
import "./ServicesStyle.css";
// import Pricing from '../components/Pricing';


const serviceList = [
    {
        icon: faYinYang,
        title: "استخراج مقاله از پایان‌نامه",
        content: "یکی از خدمات تخصصی ما در اسکولارایز، استخراج مقاله از پایان‌نامه‌های دانشجویان کارشناسی ارشد و دکتری است. بسیاری از دانشجویان برای اخذ مجوز دفاع از پایان‌نامه نیاز به چاپ مقاله‌ای مرتبط با تحقیقات خود دارند. ما با بهره‌گیری از تیمی متخصص و با تجربه، این فرایند را به شکلی دقیق و حرفه‌ای انجام می‌دهیم. کارشناسان ما با بررسی پایان‌نامه شما، موضوعات و نکات کلیدی قابل استخراج را شناسایی کرده و آنها را در قالب یک مقاله علمی تدوین می‌کنند. این خدمات برای اطمینان از موفقیت در چاپ مقالات و دفاع سریع از پایان‌نامه بسیار حائز اهمیت است.",
    },
    {
        icon: faPenFancy,
        title: "نگارش مقالات برای مجلات معتبر",
        content: "نوشتن یک مقاله علمی که توانایی چاپ در مجلات برتر داخلی و خارجی را داشته باشد، نیازمند دقت، تخصص و تجربه فراوان است. در اسکولارایز، تیمی از اساتید برتر دانشگاهی و پژوهشگران برجسته، نگارش مقالات علمی شما را به‌عهده می‌گیرند. ما در فرایند نگارش، تمامی استانداردهای علمی و نگارشی مورد نیاز مجلات معتبر را رعایت می‌کنیم تا شانس پذیرش و چاپ مقاله شما به حداکثر برسد. اگر به دنبال ارتقای رزومه علمی خود از طریق انتشار مقالات در مجلات با اعتبار بالا هستید،اسکولارایز بهترین گزینه برای شماست.",
    },
    {
        icon: faRocket,
        title: "تقویت رزومه اپلای",
        content: "اپلای به دانشگاه‌های بین‌المللی و موسسات برتر جهان نیازمند یک رزومه قدرتمند و بی‌نقص است. در اسکولارایز، با توجه به نیازهای خاص هر فرد، خدمات تقویت رزومه ارائه می‌شود. ما با بررسی دقیق تجربه‌ها، مهارت‌ها و دستاوردهای شما، رزومه‌ای می‌سازیم که به‌طور موثر نقاط قوت شما را برجسته کرده و شانس موفقیت در فرایند اپلای را افزایش می‌دهد. فرقی نمی‌کند که هدف شما اپلای برای مقطع کارشناسی، ارشد، دکتری یا حتی یک موقعیت شغلی باشد، ما در کنار شما خواهیم بود تا بهترین نسخه از رزومه خود را ارائه دهید.",
    },

    {
        icon: faRandom,
        title: "تقویت مهارت‌های زبانی و آمادگی برای آزمون‌های زبان",
        content: "یکی از مهمترین چالش‌های اپلای به دانشگاه‌های خارجی، تسلط به زبان انگلیسی و موفقیت در آزمون‌های زبان مانند TOEFL و IELTS است. ما در اسکولارایز خدماتی ارائه می‌دهیم که به شما کمک می‌کند تا مهارت‌های زبانی خود را تقویت کرده و با آمادگی کامل در این آزمون‌ها شرکت کنید. ما با تمرکز بر چهار مهارت اصلی زبان (شنیداری، گفتاری، خواندن و نوشتن) و ارائه راهکارهای اختصاصی برای هر بخش از آزمون، شما را در رسیدن به نمره مطلوب یاری می‌کنیم.",
    },
    {
		icon: faPen,
        title: "ادیت نیتیو مقاله",
        content:  "یکی دیگر از خدمات ویژه ما در اسکولارایز، ادیت نیتیو مقالات است. اگر شما مقاله‌ای به زبان انگلیسی نوشته‌اید و نیاز به ویرایش دقیق و حرفه‌ای توسط افراد بومی زبان دارید، این سرویس مناسب شماست. تیم ویراستاران ما که از پژوهشگران بومی زبان انگلیسی هستند، مقالات شما را از نظر ساختار، گرامر، واژگان و روان بودن متن بررسی و ویرایش می‌کنند تا مقاله شما به سطح استانداردهای جهانی نزدیک شود. این ادیت نیتیو به شما کمک می‌کند تا مقالات خود را با اطمینان بیشتری به مجلات علمی بین‌المللی ارسال کنید و شانس پذیرش بالاتری داشته باشید.",
    },
    {
        icon: faPaperclip,
        title: "سابمیت سریع مقاله",
        content: "در بسیاری از موارد، دانشجویان به دلیل محدودیت زمانی نیاز به ارسال سریع مقاله به مجلات علمی دارند. در اسکولارایز، ما خدمات سابمیت سریع و تضمینی مقالات را ارائه می‌دهیم. این خدمات مخصوص دانشجویان کارشناسی ارشد و دکتری است که به دنبال دفاع سریع از پایان‌نامه خود هستند یا قصد شرکت در آزمون‌های دکتری را دارند. با استفاده از این سرویس، مقاله شما در کوتاه‌ترین زمان ممکن به مجلات مورد نظر ارسال می‌شود و شما می‌توانید با خیالی آسوده بر روی مراحل دیگر فرایند اپلای تمرکز کنید.",
    },
    {

        icon: faUser,
        title: "مشاوره رایگان",
        content: "ما در اسکولارایز، معتقدیم که اولین گام برای موفقیت در هر فرایندی، مشاوره درست و به‌موقع است. به همین دلیل، خدمات مشاوره رایگان را برای تمامی دانشجویان و پژوهشگران عزیز ارائه می‌دهیم. تیم ما از کارشناسان با تجربه آماده است تا به شما در انتخاب بهترین خدمات و مسیرهای ممکن کمک کند. فقط کافیست با ما تماس بگیرید یا از طریق وب‌سایت ما درخواست خود را ارسال کنید. کارشناسان ما به محض دریافت فایل یا درخواست شما، در اسرع وقت با شما تماس خواهند گرفت تا به تمامی سوالات و نیازهای شما پاسخ دهند.",
    },

    {
        icon: faPhone,
        title: "چرا ما را انتخاب کنید؟",
        content: "تجربه، تخصص و تعهد ما به کیفیت، اسکولارایز را به انتخاب اول بسیاری از دانشجویان و پژوهشگران تبدیل کرده است. ما با ارائه خدمات تخصصی و سریع، اطمینان می‌دهیم که در تمامی مراحل از نگارش مقاله تا ارسال و تقویت رزومه، در کنار شما خواهیم بود. هدف ما این است که فرایند اپلای و پذیرش شما را تا حد امکان ساده و کارآمد کنیم.",
    },
];


const ServiceItem = ({ service }) => (
	<div className="ezy__service16-item p-3 p-md-4 p-xl-5">
		<div className="ezy__service16-icon mb-4">
			<FontAwesomeIcon icon={service.icon} />
		</div>
		<h4 className="ezy__service16-title fs-4 mb-3">{service.title}</h4>
		<p className="ezy__service16-content mb-0">{service.content}</p>
	</div>
);

ServiceItem.propTypes = {
	service: PropTypes.object.isRequired,
};



const Services = () => {
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
            });
        }, []);
    

	return (
		<section className="ezy__service16 light">
			<Container>
				<Row className="justify-content-center mb-4 mb-md-5">
					<Col lg={6} className="text-center">
						<h2 className="ezy__service16-heading mb-4">خدمات ما</h2>
						<p className="ezy__service16-sub-heading mb-0" dir="rtl" style={{"text-align":"justify", "text-justify":"inter-word",}}>
                        ما در گروه‌اسکولارایز طیف گسترده‌ای از خدمات مرتبط با پژوهش‌های علمی ارائه می‌دهیم. تیم ما از پژوهشگران و اساتید برجسته دانشگاهی تشکیل شده که تجربه وسیعی در زمینه‌های مختلف علمی دارند. خدمات ما با هدف کمک به دانشجویان و پژوهشگران برای انتشار مقالات در مجلات معتبر داخلی و خارجی طراحی شده است. این خدمات به شما کمک می‌کند تا کیفیت پژوهش خود را افزایش دهید و شانس موفقیت بالاتری در مقاطع بالاتر داشته باشید.
						</p>
					</Col>
				</Row>
				<Row className="ezy__service16-list m-0"  style={{ textAlign: 'justify' , fontSize:"1.1rem"}} dir="rtl">
					{serviceList.map((service, i) => (
						<Col sm={6} md={4} className="p-0" key={i}>
							<ServiceItem service={service} />
						</Col>
					))}
				</Row>
                <Row className="justify-content-center mb-4 mb-md-5" style={{marginTop: "100px"}}>
					
                    <Col lg={6}>
                        <img
                            src={pic}
                            alt=""
                            className="img-fluid"
                        />
                    </Col>
                    
                    
                    <Col lg={6} className="text-center" style={{marginTop: "20px", padding: "20px"}}>
						<h2 className="ezy__service16-heading mb-4">
                            <p className="ezy__service16-sub-heading mb-0" dir="rtl" style={{"text-align":"justify", "text-justify":"inter-word",}}>
                            اگر به دنبال ارتقای حرفه‌ای و علمی خود هستید و نیاز به راهنمایی و خدمات تخصصی دارید،اسکولارایز آماده است تا در این مسیر همراه شما باشد. برای دریافت اطلاعات بیشتر و شروع همکاری، با ما تماس بگیرید یا سفارش خود را از طریق وب‌سایت ثبت کنید.
                            </p>
                        </h2>
                        <Link to="/" state={{ targetId: "contactus" }}>
                            <Button 
                            variant="secondary"
                            size="lg"
                            active
                            style={{
                                transform: hovered ? 'scale(1.3)' : 'scale(1)', // Apply scale on hover
                                transition: 'transform 0.3s ease-in-out', // Smooth transition
                            }}
                            onMouseEnter={() => setHovered(true)} // Trigger hover state
                            onMouseLeave={() => setHovered(false)} // Reset hover state
                            >                                
                                تماس با ما 
                            </Button>
                        </Link>
					</Col>


				</Row>


			</Container>
            {/* <Pricing /> */}
		</section>
	);
};

export default Services;
